import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { LangLink } from '../common/LangLink';
const AuthLayout = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-neutral-50 dark:bg-neutral-900 p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <LangLink
            to="/"
            className="inline-flex items-center gap-2 text-3xl font-extrabold font-display text-primary"
          >
            <FontAwesomeIcon icon={faCoffee} />
            <span>{t('common.appName')}</span>
          </LangLink>
        </div>
        <main className="bg-white dark:bg-neutral-800 rounded-xl shadow-card p-6 sm:p-8">
          <Outlet />{' '}
          {/* Aquí se renderizarán los formularios de Login y Register */}
        </main>
      </div>
    </div>
  );
};

export default AuthLayout;
